<div class="flex justify-center px-4">
  <div class="container mx-auto">
    <div class="flex flex-col lg:flex-row md:mt-32 mt-24 gap-8">
      <app-profile-info
        class="hidden md:block lg:w-1/4"
        [emailVerified]="(user$ | async)?.emailVerified!"
        [profilePicture]="(user$ | async)?.profilePicture!"
        [createdAt]="(user$ | async)?.createdAt!"
        (filtersChanged)="selectProfile($event)"
      ></app-profile-info>

      <main class="lg:w-3/4 bg-white border border-gray-200 rounded-2xl p-6 md:p-8">
        <h2 class="text-3xl font-extrabold mb-8 text-gray-900">My Profile</h2>
        <app-profile-info
          class="md:hidden block mb-5"
          [emailVerified]="(user$ | async)?.emailVerified!"
          [profilePicture]="(user$ | async)?.profilePicture!"
          [createdAt]="(user$ | async)?.createdAt!"
          (filtersChanged)="selectProfile($event)"
        ></app-profile-info>
        <!-- 2 Columns on large screens -->
        <form (ngSubmit)="onSubmit()" [formGroup]="userForm">
          <div class="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <!-- Your Details -->
            <div>
              <h3 class="text-2xl font-semibold mb-4 text-gray-800">
                Your Details
              </h3>

              <!-- Full Name -->
              <div class="mb-4">
                <label
                  class="block text-gray-700 font-semibold mb-2"
                  for="fullName"
                  >Full Name <span class="text-red-600">*</span>
                </label>
                <input
                  type="text"
                  id="fullName"
                  name="fullName"
                  formControlName="name"
                  required
                  class="w-full px-4 py-3 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[var(--primary)]"
                />
              </div>

              <!-- Email -->
              <div class="mb-4">
                <label
                  class="block text-gray-700 font-semibold mb-2"
                  for="email"
                  >Email Address</label
                >
                <input
                  type="email"
                  id="email"
                  name="email"
                  formControlName="email"
                  required
                  class="w-full px-4 py-3 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[var(--primary)]"
                />
              </div>

              <!-- Phone -->
              <div class="mb-4">
                <label
                  class="block text-gray-700 font-semibold mb-2"
                  for="phone"
                  >Phone Number <span class="text-red-600">*</span></label
                >
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  formControlName="contactNo"
                  required
                  class="w-full px-4 py-3 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[var(--primary)]"
                />
              </div>
            </div>

            <!-- Shipping Details -->
            <!-- <div>
              <h3 class="text-2xl font-semibold mb-4 text-gray-800">
                Shipping Details
              </h3>

              <div class="mb-4">
                <label
                  class="block text-gray-700 font-semibold mb-2"
                  for="address"
                  >Address</label
                >
                <textarea
                  id="address"
                  name="address"
                  rows="3"
                  formControlName="address"
                  required
                  class="w-full px-4 py-3 rounded-xl border border-gray-300 resize-none focus:outline-none focus:ring-2 focus:ring-[var(--primary)]"
                ></textarea>
              </div>

              <div class="mb-4">
                <label
                  class="block text-gray-700 font-semibold mb-2"
                  for="country"
                  >Country</label
                >
                <input
                  type="text"
                  id="country"
                  name="country"
                  formControlName="country"
                  required
                  class="w-full px-4 py-3 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[var(--primary)]"
                />
              </div>

              <div class="mb-4">
                <label
                  class="block text-gray-700 font-semibold mb-2"
                  for="province"
                  >Province</label
                >
                <input
                  type="text"
                  id="province"
                  name="province"
                  formControlName="province"
                  required
                  class="w-full px-4 py-3 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[var(--primary)]"
                />
              </div>
              <div class="mb-4">
                <label class="block text-gray-700 font-semibold mb-2" for="city"
                  >City</label
                >
                <input
                  type="text"
                  id="city"
                  name="city"
                  formControlName="city"
                  required
                  class="w-full px-4 py-3 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[var(--primary)]"
                />
              </div>
              <div class="mb-4">
                <label
                  class="block text-gray-700 font-semibold mb-2"
                  for="postalCode"
                  >Postal Code</label
                >
                <input
                  type="text"
                  id="postalCode"
                  name="postalCode"
                  formControlName="postalCode"
                  required
                  class="w-full px-4 py-3 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[var(--primary)]"
                />
              </div>
            </div> -->
            <div>
              <h3 class="text-2xl font-semibold mb-4 text-gray-800">
                Shipping Details
              </h3>

              <!-- Address -->
              <div class="mb-4">
                <label class="block text-gray-700 font-semibold mb-2">
                  Address <span class="text-red-600">*</span>
                </label>
                <textarea
                  rows="3"
                  formControlName="address"
                  class="w-full px-4 py-3 rounded-xl border border-gray-300 resize-none focus:outline-none focus:ring-2 focus:ring-[var(--primary)]"
                ></textarea>
              </div>

              <!-- Country -->
              <div class="mb-4">
                <label class="block text-gray-700 font-semibold mb-2">
                  Country <span class="text-red-600">*</span>
                </label>
                <select
                  formControlName="country"
                  class="w-full px-4 py-3 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[var(--primary)]"
                >
                  <option *ngFor="let country of countries" [value]="country">
                    {{ country }}
                  </option>
                </select>
              </div>

              <!-- Province -->
              <div class="mb-4">
                <label class="block text-gray-700 font-semibold mb-2">
                  Province <span class="text-red-600">*</span>
                </label>
                <select
                  formControlName="province"
                  class="w-full px-4 py-3 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[var(--primary)]"
                >
                  <option value="" disabled>Select Province</option>
                  <option *ngFor="let province of provinces" [value]="province">
                    {{ province }}
                  </option>
                </select>
              </div>

              <!-- City -->
              <div class="mb-4">
                <label class="block text-gray-700 font-semibold mb-2">
                  City <span class="text-red-600">*</span>
                </label>
                <select
                  formControlName="city"
                  class="w-full px-4 py-3 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[var(--primary)]"
                >
                  <option value="" disabled>Select City</option>
                  <option *ngFor="let city of availableCities" [value]="city">
                    {{ city }}
                  </option>
                </select>
              </div>

              <!-- Postal Code -->
              <div class="mb-4">
                <label class="block text-gray-700 font-semibold mb-2">
                  Postal Code <span class="text-red-600">*</span>
                </label>
                <input
                  type="text"
                  formControlName="postalCode"
                  class="w-full px-4 py-3 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[var(--primary)]"
                />
              </div>
            </div>
          </div>
          <div class="flex flex-col md:flex-row gap-4 justify-end mt-8">
            <button
              type="submit"
              [disabled]="userForm.invalid || loading"
              class="w-full md:w-auto px-8 py-3 bg-[var(--primary)] group text-white rounded-xl border border-[var(--primary)] font-semibold cursor-pointer hover:bg-gray-100 hover:text-[var(--primary)] transition flex items-center justify-center gap-1"
            >
              @if (loading) {
                <app-items-loading
                  size="w-5 h-5"
                  class="[&>svg>circle]:stroke-white [&>svg>path]:stroke-white group-hover:[&>svg>circle]:stroke-[var(--primary)] group-hover:[&>svg>path]:stroke-[var(--primary)]"
                ></app-items-loading>
              } @else {
                <fa-icon [icon]="faSave" class="w-5 h-5"></fa-icon>
              }
              Update Profile
            </button>
          </div>
        </form>

        <!-- Password Change -->
        <form
          [formGroup]="passwordForm"
          (ngSubmit)="changePassword()"
          class="border-t border-gray-300 pt-6 mt-6"
        >
          <h3 class="text-2xl font-semibold mb-4 text-gray-800">
            Change Password
          </h3>
          @if(!isEmailPasswordUser){
            <!-- Optional message for Google users -->
            <p class="text-sm text-gray-500 mt-1">
              Password is managed by Google. Use Google account settings to
              change it.
            </p>
          }@else {
            
         
          <div class="mb-4">
            <label
              class="block text-gray-700 font-semibold mb-2"
              for="currentPassword"
              >Current Password</label
            >
            <input
              type="password"
              id="currentPassword"
              name="currentPassword"
              formControlName="currentPassword"
              required
              class="w-full px-4 py-3 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[var(--primary)]"
            />
            
          </div>
          <div class="mb-4">
            <label
              class="block text-gray-700 font-semibold mb-2"
              for="newPassword"
              >New Password</label
            >
            <input
              type="password"
              id="newPassword"
              name="newPassword"
              formControlName="newPassword"
              required
              class="w-full px-4 py-3 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[var(--primary)]"
            />
          </div>
          <!-- Submit + Change Password -->
          <div class="flex flex-col md:flex-row gap-4 justify-end mt-8">
            <button
              type="submit"
              [disabled]="passwordForm.invalid || isPasswordChanging"
              class="w-full md:w-auto px-8 py-3 bg-[var(--primary)] group text-white rounded-xl border border-[var(--primary)] font-semibold cursor-pointer hover:bg-gray-100 hover:text-[var(--primary)] transition flex items-center justify-center gap-2"
            >
              @if (isPasswordChanging) {
                <app-items-loading
                  size="w-5 h-5"
                  class="[&>svg>circle]:stroke-white [&>svg>path]:stroke-white group-hover:[&>svg>circle]:stroke-[var(--primary)] group-hover:[&>svg>path]:stroke-[var(--primary)]"
                ></app-items-loading>
              } @else {
                <fa-icon [icon]="faLock" class="w-5 h-5"></fa-icon>
              }
              Change Password
            </button>
          </div>
           }
        </form>

        <form
          [formGroup]="deleteForm"
          (ngSubmit)="onDeleteAccount()"
          class="border-t border-gray-300 pt-6 mt-6"
        >
          <h3 class="text-2xl font-semibold mb-4 text-gray-800">
            Delete Account
          </h3>
          <p class="mt-1">
            Are you sure you want to delete your account? This action is
            <strong>permanent</strong> and will remove your profile, order
            history, and saved addresses.
          </p>
          @if(isEmailPasswordUser){
            <div class="my-4">
            <label
              class="block text-gray-700 font-semibold mb-2"
              for="currentPassword"
              >Current Password</label
            >
            <input
              type="password"
              id="currentPassword"
              name="currentPassword"
              formControlName="currentPassword"
              required
              class="w-full px-4 py-3 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[var(--primary)]"
            />
          </div>
          }
          <div class="flex flex-col md:flex-row gap-4 justify-end mt-8">
            <button
              type="submit"
              [disabled]="deleting"
              class="w-full md:w-auto px-8 py-3 bg-red-600 group border border-red-600 text-white rounded-xl font-semibold cursor-pointer hover:bg-gray-100 hover:text-red-600 transition flex items-center justify-center gap-2"
            >
              @if (deleting) {
                <app-items-loading
                  size="w-5 h-5"
                  class="[&>svg>circle]:stroke-white [&>svg>path]:stroke-white group-hover:[&>svg>circle]:stroke-red-600 group-hover:[&>svg>path]:stroke-red-600"
                ></app-items-loading>
              } @else {
                <fa-icon [icon]="faTrash" class="w-5 h-5"></fa-icon>
              }
              Delete Account
            </button>
          </div>
        </form>
      </main>
    </div>
  </div>
</div>
